<template>
  <div :class="brandClasses.reviewsRatingSummary" data-test-id="rating-summary">
    <div v-if="reviewsData?.rollup?.reviewCount" :class="brandClasses.reviewsCount">
      <p
        v-if="ratio > recommendationRateThreshold"
        class="title-5"
        :class="brandClasses.reviewsRecommendations"
        data-test-id="rating-recommendation"
      >
        {{ replaceAll($t.customerRecommendedRatio, { ratio }) }}
      </p>
      <base-link
        :class="brandClasses.reviewsLink"
        :to="{
          hash: '#reviews',
          query: route.query,
          state: history.state,
        }"
        @click="$gtm.push('pdpPage.onViewReviews')"
      >
        <vf-rating :value="reviewsData.rollup.averageRating" />
        <span aria-hidden="true" class="text-sm lh-4 underlined ">
          {{
            replaceAll(
              $pluralize($t.numberOfReviews, reviewsData.rollup.reviewCount),
              { reviewsCount: reviewsData.rollup.reviewCount },
            )
          }}
        </span>
        <span class="sr-only">
          <template v-if="reviewsData.rollup.reviewCount">
            {{
              replaceAll(
                $pluralize($t.viewNumberOfReviews, reviewsData.rollup.reviewCount),
                { reviewsCount: reviewsData.rollup.reviewCount },
              )
            }}
          </template>
          <template v-else>
            {{ $t.scrollToReviews }}
          </template>
        </span>
      </base-link>
    </div>
    <base-button v-else class="text-sm underlined" @click="openWriteReview">
      {{ $t.writeFirstReview }}
    </base-button>
    <dialog-review-write />
  </div>
</template>

<script lang="ts" setup>
import type { Product } from '#root/api/clients/product/data-contracts'
import type { ProductReviewsData } from '#types/components/product/reviews'

export type Props = {
  product: Product
  reviewsData?: ProductReviewsData
}

const { product, reviewsData } = defineProps<Props>()

const {
  brandClasses,
  reviews: { dialogOptions, recommendationRateThreshold }
} = useAppConfig().pages?.pdp || {}
const { $gtm } = useNuxtApp()
const route = useRoute()
const { history } = useRouter().options

const DialogReviewWrite = createDialog('review-write', dialogOptions.reviewWrite)

const ratio = computed(() => Math.round((reviewsData?.rollup?.recommendedRatio || 0) * 100))

const openWriteReview = () => {
  $gtm.push('pdpPage.onWriteReview')
  DialogReviewWrite.open({
    pageId: reviewsData?.reviewsPageId || reviewsData?.pageId,
    productId: product?.id
  })
}
</script>
